/**
 * Cache de líneas WhatsApp tenant de Voice, por retailerId.
 *
 * Module-level para sobrevivir navegación in-app (evita refetch entre pantallas),
 * y se limpia al resetear el store (cambio de sesión/logout) vía `resetStore`.
 */

/** @type {Map<string, Array<object>>} */
const cacheByRetailer = new Map();

const cacheKey = (retailerId) => String(retailerId);

export function hasTenantLinesCache(retailerId) {
  return retailerId != null && cacheByRetailer.has(cacheKey(retailerId));
}

export function readTenantLinesCache(retailerId) {
  return cacheByRetailer.get(cacheKey(retailerId)) ?? [];
}

export function writeTenantLinesCache(retailerId, lines) {
  cacheByRetailer.set(cacheKey(retailerId), lines);
}

export function clearTenantLinesCache() {
  cacheByRetailer.clear();
}
